import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import jadeIdentificationServiceApi from '../../api/jadeIdentificationService';
import { message } from 'antd';

export const fetchJadeIdentificationServiceList = createAsyncThunk(
  'jadeIdentificationService/fetchList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await jadeIdentificationServiceApi.pageList(params);
      return response.data;
    } catch (error) {
      message.error('获取玉石鉴定服务列表失败');
      return rejectWithValue(error.response.data);
    }
  }
);

export const getJadeIdentificationServiceById = createAsyncThunk(
  'jadeIdentificationService/getById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await jadeIdentificationServiceApi.getById(id);
      return response.data;
    } catch (error) {
      message.error('获取玉石鉴定服务详情失败');
      return rejectWithValue(error.response.data);
    }
  }
);

export const createJadeIdentificationService = createAsyncThunk(
  'jadeIdentificationService/create',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await jadeIdentificationServiceApi.create(data);
      message.success('创建玉石鉴定服务成功');
      dispatch(fetchJadeIdentificationServiceList());
      return response.data;
    } catch (error) {
      message.error(error.response?.data?.message || '创建玉石鉴定服务失败');
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateJadeIdentificationService = createAsyncThunk(
  'jadeIdentificationService/update',
  async ({ id, data }, { dispatch, rejectWithValue }) => {
    try {
      const response = await jadeIdentificationServiceApi.update(id, data);
      message.success('更新玉石鉴定服务成功');
      dispatch(fetchJadeIdentificationServiceList());
      return response.data;
    } catch (error) {
      message.error(error.response?.data?.message || '更新玉石鉴定服务失败');
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteJadeIdentificationService = createAsyncThunk(
  'jadeIdentificationService/delete',
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const response = await jadeIdentificationServiceApi.delete(id);
      message.success('删除玉石鉴定服务成功');
      dispatch(fetchJadeIdentificationServiceList());
      return response.data;
    } catch (error) {
      message.error(error.response?.data?.message || '删除玉石鉴定服务失败');
      return rejectWithValue(error.response.data);
    }
  }
);

const jadeIdentificationServiceSlice = createSlice({
  name: 'jadeIdentificationService',
  initialState: {
    list: [],
    total: 0,
    page: 1,
    pageSize: 10,
    loading: false,
    error: null,
    currentService: null
  },
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setCurrentService: (state, action) => {
      state.currentService = action.payload;
    },
    clearCurrentService: (state) => {
      state.currentService = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJadeIdentificationServiceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchJadeIdentificationServiceList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.records;
        state.total = action.payload.total;
      })
      .addCase(fetchJadeIdentificationServiceList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getJadeIdentificationServiceById.fulfilled, (state, action) => {
        state.currentService = action.payload;
      })
      .addCase(getJadeIdentificationServiceById.rejected, (state) => {
        state.currentService = null;
      });
  }
});

export const { setPage, setPageSize, setCurrentService, clearCurrentService } = jadeIdentificationServiceSlice.actions;
export default jadeIdentificationServiceSlice.reducer;